'use strict';

/**
 * Directive: Focus Inputs
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export selectOnFocus for ES6 usage
 *          8.0.0 #572 Fix `select-on-focus` Directive
 *          7.8.0 #513 Update Main Library for Job Override
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com> 
 *
 * @copyright (c) 2015-2020 Build Centrix
 */
var selectOnFocus = angular.module('wd.select', [])
    .directive('selectOnFocus', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                var focusedElement = null;

                element.on('focus', function () {

                    var self = this;

                    if (focusedElement != self) {

                        focusedElement = self;
                        self.select();

                    }
                });

                element.on('blur', function () {

                    focusedElement = null;

                });

            }

        }

    });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = selectOnFocus;
}     
// EOF